import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@/lib/v2/components';

type HeaderSidePanelProps = {
  title?: string;
  onCancel?: () => void;
  onSave?: () => void;
};

const HeaderSidePanel = ({ title, onCancel, onSave }: HeaderSidePanelProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-between border-b px-6 py-3">
      <Text>{title}</Text>
      <div className="flex gap-2">
        <Button secondary standard size="small" onClick={onCancel}>
          {t('HeaderSidePanel.cancel')}
        </Button>
        <Button primary size="small" onClick={onSave}>
          {t('HeaderSidePanel.save')}
        </Button>
      </div>
    </div>
  );
};

export default memo(HeaderSidePanel);
